import { Image, Text, View } from '@react-pdf/renderer'
import React from 'react'
import Header from './Header'
import TableHeader from './TableHeader'
import SizeItem from './SizeItem'
import TableRow from './TableRow'
import { logger } from '../../../../../utils'

const BOMCheck = ({ data, order }) => {

    return (
        <>
            <Header />
            <View style={{ marginBottom: "15px" }}>
                {/* <SizeItem item={item} /> */}
                <TableHeader />
                {
                    order.job_order_bom_check.map((item, index) => (
                        <TableRow key={index} item={item} />
                    ))
                }

                <View
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        flexDirection: "row",
                        justifyContent: "center",
                        gap: "15px",
                        margin: "15px"
                    }}
                >
                    {
                        [1, 2, 3, 4, 5].map((_, index) => {
                            return (
                                <Image
                                    key={index}
                                    style={{
                                        height: 100,
                                        width: 125,
                                    }}
                                    // src="/images/bom.png"
                                    src="https://images.pexels.com/photos/3812433/pexels-photo-3812433.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                                />
                            )
                        })
                    }
                </View>
            </View>

        </>
    )
}

export default BOMCheck